function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Inner Plugin Iframe",
  clipPath: "url(#clip0_278_922)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10ZM10.3587 7.3825C9.38625 7.7875 7.44125 8.625 4.52625 9.895C4.05375 10.0825 3.805 10.2675 3.7825 10.4475C3.745 10.7512 4.12625 10.8713 4.645 11.035L4.86375 11.1038C5.37375 11.27 6.06125 11.4637 6.4175 11.4713C6.7425 11.4788 7.10375 11.3463 7.5025 11.0713C10.2262 9.2325 11.6325 8.30375 11.72 8.28375C11.7825 8.26875 11.87 8.25125 11.9275 8.30375C11.9862 8.355 11.98 8.45375 11.9738 8.48C11.9363 8.64125 10.44 10.0312 9.66625 10.7512C9.425 10.9762 9.25375 11.135 9.21875 11.1713C9.14168 11.25 9.06333 11.3275 8.98375 11.4038C8.50875 11.8612 8.15375 12.2038 9.0025 12.7638C9.41125 13.0338 9.73875 13.255 10.065 13.4775C10.42 13.72 10.775 13.9613 11.235 14.2638C11.3512 14.3387 11.4638 14.42 11.5725 14.4975C11.9863 14.7925 12.36 15.0575 12.8188 15.015C13.0863 14.99 13.3625 14.74 13.5025 13.99C13.8337 12.2188 14.485 8.3825 14.635 6.80125C14.6442 6.6698 14.6387 6.53775 14.6187 6.4075C14.607 6.3024 14.5561 6.20557 14.4763 6.13625C14.3625 6.05774 14.2269 6.01706 14.0887 6.02C13.7137 6.02625 13.135 6.2275 10.3587 7.3825Z",
  fill: "#385CAD"
})));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_278_922"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

const SvgInnerPluginIframe3 = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInnerPluginIframe3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Inner Plugin Iframe (3).b8b50648.svg";
export { ForwardRef as ReactComponent };